import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'
import LPContainer from './LPContainer'
import Image from 'next/image'

const MessageUsSection: FCC<{ className?: string }> = ({ className }) => {
  const { t, i18n } = useTranslation()

  return (
    <>
      <div className="flex flex-col tablet:flex-row mt-6 relative">
        <LPContainer className="w-full">
          <div className="flex flex-col tablet:flex-row py-[94px]">
            <div className="flex-1">
              <TypographyText className="text-[21px] text-gray-700 font-normal tablet:mr-[120px]">
                {t('aboutUs:message_coo_description')}
              </TypographyText>
            </div>
            <div className="flex-1 flex flex-col justify-center max-w-[804px] mx-auto">
              <TypographyText className="text-lg font-medium text-green-500 uppercase">
                {t('aboutUs:message_coo')}
              </TypographyText>
              <div className="text-gray-900 text-3xl mt-6 animate-fadeInUp">
                {t('aboutUs:message_coo_content')}
              </div>
              <div className="mt-6 flex items-center space-x-4">
                <div>
                  <TypographyText className="text-lg font-medium text-gray-700">
                    {t('aboutUs:message_coo_name')}
                  </TypographyText>
                  <TypographyText className="text-base font-normal text-gray-600">
                    {t('aboutUs:message_coo_title')}
                  </TypographyText>
                </div>
              </div>
            </div>
          </div>
        </LPContainer>
        <div className="flex flex-col tablet:flex-row absolute top-0 left-0 right-0 bottom-0 -z-[1]">
          <div className="w-1/2"></div>
          <div className="w-1/2 bg-[url('/img/feature/lp/new/bg-gradient-from-white-to-blue.png')] bg-center bg-cover" />
        </div>
      </div>
      <div className="flex flex-col tablet:flex-row mt-10 relative">
        <LPContainer className="w-full">
          <div className="flex flex-col tablet:flex-row py-[94px]">
            <div className="flex-1 flex flex-col justify-center max-w-[804px] mx-auto">
              <TypographyText className="text-lg font-medium text-green-500 uppercase">
                {t('aboutUs:message_ceo')}
              </TypographyText>
              <div className="text-gray-900 text-3xl mt-6 animate-fadeInUp">
                {t('aboutUs:message_ceo_content')}
              </div>
              <div className="mt-6 flex items-center space-x-4">
                <div>
                  <TypographyText className="text-lg font-medium text-gray-700">
                    {t('aboutUs:message_ceo_name')}
                  </TypographyText>
                  <TypographyText className="text-base font-normal text-gray-600">
                    {t('aboutUs:message_ceo_title')}
                  </TypographyText>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <TypographyText className="text-4xl text-gray-900 font-medium tablet:ml-[120px]">
                {t('aboutUs:message_ceo_description')}
              </TypographyText>
              <TypographyText className="text-base text-gray-700 font-normal tablet:ml-[120px] mt-6">
                {t('aboutUs:message_ceo_description01')}
              </TypographyText>
            </div>
          </div>
        </LPContainer>
        <div className="flex flex-col tablet:flex-row absolute top-0 left-0 right-0 bottom-0 -z-[1]">
          <div className="w-1/2 bg-[url('/img/feature/lp/new/bg-gradient-from-blue-to-white.png')] bg-center bg-cover" />
          <div className="w-1/2"></div>
        </div>
      </div>
    </>
  )
}

export default MessageUsSection
